<template>
    <div v-if="_hasAccess('schedule.access')">
        <b-nav-item-dropdown
            v-if="isNavHorizontal"
            data-top-right-id="tasks"
            no-caret
            right
        >
            <template slot="button-content">
                <i id="tasks_bell_top" class="fas fa-tasks"></i>
                <span class="d-lg-none">Task</span>
                <div
                    v-if="isNotificationEnabled && badgeCount > 0"
                    :class="['badge', { 'enhanced-layout': _isEnhancedLayout }]"
                >
                    {{ badgeCount > 99 ? "99+" : badgeCount }}
                </div>
            </template>
            <b-dropdown-item
                data-top-tasks-id="assigned-to-me"
                to="/schedule/tasks?status=3"
            >
                <i class="fas fa-tasks child"></i>
                {{ incompleteLabel }}
            </b-dropdown-item>
            <b-dropdown-item
                data-top-tasks-id="created-by-me"
                to="/schedule/tasks?status=4"
            >
                <i class="fas fa-tasks child"></i>
                Created by Me
            </b-dropdown-item>
            <b-dropdown-item
                v-if="_hasAccess('schedule.task.access')"
                data-top-tasks-id="open-in-progress"
                to="/schedule/tasks?task_status=0"
            >
                <i class="fas fa-tasks child"></i>
                All Open & In Progress
            </b-dropdown-item>
            <b-dropdown-item
                v-if="_hasAccess('schedule.task.access')"
                data-top-tasks-id="completed"
                to="/schedule/tasks?task_status=1"
            >
                <i class="fas fa-tasks child"></i>
                All Completed
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item
                data-top-tasks-id="new-task"
                @click.stop="showNewTaskModal()"
            >
                <i class="fas fa-plus-circle child" style="color: #678f35;"></i>
                New Task
            </b-dropdown-item>
        </b-nav-item-dropdown>

        <li v-else class="left-option">
            <button class="option-toggle" @click="$emit('toggle-visibility')">
                <i id="tasks_bell_top" class="fas fa-tasks"></i>
                <span class="label">Task</span>
                <span
                    v-if="isNotificationEnabled && badgeCount > 0"
                    class="badge"
                >
                    {{ badgeCount > 99 ? "99+" : badgeCount }}
                </span>
            </button>
            <ul v-if="showOptionMenu" class="option-menu" id="links">
                <li>
                    <a
                        @click.prevent="
                            handleMenuClick('/schedule/tasks?status=3')
                        "
                        data-top-tasks-id="assigned-to-me"
                        href="/view/schedule/tasks?status=3"
                        class="option-menu-item"
                    >
                        <i class="fas fa-tasks child"></i>
                        {{ incompleteLabel }}
                    </a>
                </li>
                <li>
                    <a
                        @click.prevent="
                            handleMenuClick('/schedule/tasks?status=4')
                        "
                        data-top-tasks-id="created-by-me"
                        href="/view/schedule/tasks?status=4"
                        class="option-menu-item"
                    >
                        <i class="fas fa-tasks child"></i>
                        Created by Me
                    </a>
                </li>
                <li v-if="_hasAccess('schedule.task.access')">
                    <a
                        @click.prevent="
                            handleMenuClick('/schedule/tasks?task_status=0')
                        "
                        data-top-tasks-id="open-in-progress"
                        href="/view/schedule/tasks?task_status=0"
                        class="option-menu-item"
                    >
                        <i class="fas fa-tasks child"></i>
                        All Open & In Progress
                    </a>
                </li>
                <li v-if="_hasAccess('schedule.task.access')">
                    <a
                        @click.prevent="
                            handleMenuClick('/schedule/tasks?task_status=1')
                        "
                        data-top-tasks-id="completed"
                        href="/view/schedule/tasks?task_status=1"
                        class="option-menu-item"
                    >
                        <i class="fas fa-tasks child"></i>
                        All Completed
                    </a>
                </li>
                <b-dropdown-divider />
                <li>
                    <button
                        data-top-tasks-id="new-task"
                        @click.stop="showNewTaskModal()"
                        class="option-menu-item"
                    >
                        <i
                            class="fas fa-plus-circle child"
                            style="color: #678f35;"
                        ></i>
                        New Task
                    </button>
                </li>
            </ul>
        </li>
    </div>
</template>

<script>
export default {
    props: {
        showNewTaskModal: {
            type: Function
        },
        isNotificationEnabled: {
            type: Boolean,
            default: false
        },
        isNavHorizontal: {
            type: Boolean,
            default: true
        },
        showOptionMenu: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        badgeCount() {
            return this.$store.getters["task/badgeCount"];
        },
        incompleteLabel() {
            let str = "Assigned to Me";

            if (this.isNotificationEnabled && this.badgeCount > 0) {
                let countStr = this.badgeCount > 99 ? "99+" : this.badgeCount;
                str += ` (${countStr})`;
            }

            return str;
        }
    },
    methods: {
        handleMenuClick(to) {
            this._toggleEnhancedLayoutMobileSideMenu();
            this.$router.push(to);
        }
    }
};
</script>

<style lang="scss" scoped>
.badge {
    transition: none;
    background: red;
    position: absolute;
    top: -3px;
    right: 0;
    font-size: 0.7em;

    &.enhanced-layout {
        color: white;
    }
}

.fas.child {
    margin-right: 5px;
}

.left-option {
    width: 100%;

    button {
        border: 0;
        outline: 0;
        background: transparent;
        width: 100%;
        font-weight: 500;

        .label {
            text-align: start;
        }
    }

    button,
    .option-menu-item {
        &:hover {
            background: rgba(255, 255, 255, 0.2);
        }

        &:focus-visible {
            box-shadow: 0 0 0 0 #fff, 0 0 0 2px rgba(59, 130, 246, 0.5),
                0 0 #0000;
        }
    }

    .option-toggle {
        display: flex;
        gap: 10px;
        height: 36px;
        align-items: center;
        justify-content: start;
        padding: 8px 12px;
        border-radius: 4px;
        color: #fff;

        .icon {
            width: 16px;
            height: 16px;
            color: #d5d5d5;
        }
    }

    .option-menu {
        display: flex;
        flex-direction: column;
        margin: 4px 0 4px 0;
        padding: 4px 0;
        list-style: none;
        border-radius: 4px;
        background: #fff;
    }

    .option-menu-item {
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 8px 12px 8px 38px;

        font-size: 0.85rem;
        font-weight: 500;

        &:hover {
            background: #c9ccde;
        }

        .icon {
            width: 15px;
            height: 15px;
        }
    }

    #links a {
        color: #000;
        font-weight: 500;
    }

    .badge {
        position: relative;
        top: 0;
    }
}
</style>
